import React, { useRef } from 'react';
import { Plus } from 'lucide-react';
import '../styles/AttachmentUploader.css';

/**
 * FileUploadButton Component
 *
 * Simple + icon button that triggers file upload dialog
 * ChatGPT-style attachment button
 *
 * @param {Function} onFileSelect - Callback when files selected (called for each file)
 * @param {boolean} disabled - Disable button
 */
const FileUploadButton = ({ onFileSelect, disabled = false }) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);

    // Call onFileSelect for each file
    files.forEach(file => {
      onFileSelect(file);
    });

    // Clear input value to allow uploading the same file again
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*,video/*"
        capture="environment"
        multiple
        onChange={handleFileChange}
        style={{ display: 'none' }}
        aria-label="File upload input"
      />
      <button
        type="button"
        className="btn-attachment-plus"
        onClick={handleButtonClick}
        disabled={disabled}
        aria-label="Attach images or videos"
        title="Attach images or videos"
      >
        <Plus size={20} />
      </button>
    </>
  );
};

export default React.memo(FileUploadButton);
